import breadcrumbsTemplate from './breadcrumb.html';
import breadcrumbsComplexTemplate from './breadcrumb_complex.html';

angular.module('BBPublicBooking').directive('bbBreadcrumbs', (PathSvc) => {

        return {
            restrict: 'A',
            replace: true,
            scope: true,
            controller: 'Breadcrumbs',
            templateUrl(element, attrs) {

                if (_.has(attrs, 'complex')) {
                    return PathSvc.directivePartial(breadcrumbsComplexTemplate.id.replace('.html', ''));
                } else {
                    return PathSvc.directivePartial(breadcrumbsTemplate.id.replace('.html', ''));
                }
            },

            link(scope) {

            }
        };
    }
);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/breadcrumb/bb_breadcrumb.directive.js